import { BnMakepaymentOtherPoliciesComponent } from '../bn-make-a-payment/bn-makepayment-other-policies/bn-makepayment-other-policies.component';
import { BnImpNoticeComponent } from '../bn-notice/bn-imp-notice/bn-imp-notice.component';
import { BnMakeCheckingSavingsPaymentComponent } from '../bn-make-a-payment/bn-make-checking-savings-payment/bn-make-checking-savings-payment.component';
import { BnMakeAPaymentLandingComponent } from '../bn-make-a-payment/bn-make-a-payment-landing/bn-make-a-payment-landing.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { BillingNewService } from '@services/common/billing-new.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, BnMakeAPaymentLandingComponent, BnMakeCheckingSavingsPaymentComponent, BnImpNoticeComponent, BnMakepaymentOtherPoliciesComponent],
  selector: 'app-bn-make-a-payment-details',
  templateUrl: './bn-make-a-payment-details.component.html',
  styleUrls: ['./bn-make-a-payment-details.component.scss']
})
export class BnMakeAPaymentDetailsComponent implements OnChanges, OnDestroy{

  @Input() policy: any; 
  @Input() isEFT: any;
  @Input() billingDetails: any;
  @Input() company: any;
  isAcmic: boolean;
  hideMethodOptions: boolean;
  showCheckingOrSavingPayment: boolean;

  constructor(
    private acmicServie: AcmicService,
    private billingNewService: BillingNewService
  ) { 
    this.isAcmic = this.acmicServie.isACMIC();
    this.setDefault(false);
  }
   ngOnChanges(changes: SimpleChanges): void {
    const prev = changes['policy']?.previousValue?.policynumber?.policyNumber;
    const curr = changes['policy']?.currentValue?.policynumber?.policyNumber;
    if (prev && prev !== curr) {
      this.setDefault(false);
    }
  }

  setDefault(flag) {
    this.hideMethodOptions = flag;
    this.showCheckingOrSavingPayment = flag;
  }

  onCheckingOrSavingsAccount() {
    this.setDefault(true);
  }

  showLandingPage() {
    this.setDefault(false);
  }

 ngOnDestroy() {
    this.billingNewService.setCheckingOrSavingsSelected(false);
  }
}
